export class AuditProgramDto {
  auditProgramId: string;
  auditName: string;
  companyId: string;
  companyName: string;
  siteId: string;
  siteName: string;
  templateId: string;
  cdFinancialYear: string;
  financialYear: string;
  auditCoverageFromDate: string;
  auditCoverageToDate: string;
  auditPeriodFromDate: string;
  auditPeriodToDate: string;
  isTriggered: string;
  clientId: string;
  triggeredBy: string;
  triggeredDate: string;
  statusId: string;
  isPostCommentPosted: string;
  isWorkflowRequired: string;
  auditWFReqId: string;
  auditWFReqStatusId: string;
  auditNCFinalizedDate: string;
  auditNCFinalizedBy: string;
  closingMeetingDate: string;
  closingMeetingStartTime: string;
  closingMeetingEndTime: string;
  closingMeetingReportFilePath: string;
  closingMeetingUpdatedby: string;
  isClosingMeetingScheduled: string;
  draftReportWfReqId: string;
  draftReportWFReqStatusId: string;
  draftReportReleasedDate: string;
  draftReportReleasedBy: string;
  draftReportFilePath: string;
  isDraftReportReleased: string;
  mcReleasedDate: string;
  mcReleasedBy: string;
  isMcReleased: string;
  iuId: string;
  finalReportReleasedDate: string;
  finalReportReleasedBy: string;
  finalReportFilePath: string;
  isFinalReportReleased: string;
  auditClosureDate: string;
  auditClosureComment: string;
  entBy: string;
  entStamp: string;
  updBy: string;
  updStamp: string;
  cdAuditStage: string;
  isPostCommentExists: string;
  isNcFinalized: string;
  auditFirmId: string;
  firmName: string;

  cdAuditStatus: string;
  cdAuditeeStage: string;

  cdAuditStageStr: string;
  cdAuditeeStageStr: string;
  isPreviewAvailable: string;
  auditAreaId: string;
}
